import { QuestionScreenLayout } from '@/features/advisor-onboarding/questionnaire/components/question-screen-layout';
import { QuestionBodyParagraph } from '@/features/advisor-onboarding/questionnaire/components/question-body-paragraph';

import { useSessionFlags } from '@/features/advisor-onboarding/questionnaire/hooks/use-session-flags';
import { useParagraphQuestion } from '@/features/advisor-onboarding/questionnaire/hooks/use-paragraph-question';
import { useQuestionScreen } from '@/features/advisor-onboarding/questionnaire/contexts/question-screen-context';

export function ParagraphScreen() {
  const { isWizardSession, isEdjPilotAdvisor } = useSessionFlags();
  const { question, answers, isSubmitting, submitAnswer } = useQuestionScreen();

  const initialValue = (answers[question.id] as string | undefined) ?? '';
  const placeholder = (question as { placeholder?: string }).placeholder;
  const canSkip = !question.required || isWizardSession || isEdjPilotAdvisor;

  const { value, setValue, isValid, submit } = useParagraphQuestion({
    question,
    initialValue,
    onSubmit: submitAnswer,
  });

  return (
    <QuestionScreenLayout
      onNext={submit}
      nextDisabled={!isValid}
      showSkip={canSkip}
      nextLabel="Done"
    >
      <QuestionBodyParagraph
        value={value}
        onChange={setValue}
        placeholder={placeholder}
        disabled={isSubmitting}
      />
    </QuestionScreenLayout>
  );
}
